import { Toast } from "vant";

export default {
    // 当前时间转换为字符串格式日期
    getCurrentTime() {
        const now = new Date();
        const year = now.getFullYear();
        const month = (now.getMonth() + 1).toString().padStart(2, '0');
        const day = now.getDate().toString().padStart(2, '0');
        const hours = now.getHours().toString().padStart(2, '0');
        const minutes = now.getMinutes().toString().padStart(2, '0');
        const seconds = now.getSeconds().toString().padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    // 字符串日期转换为日期对象
    convertToDateObject(dateString) {
        // 解析日期字符串，确保月份和分钟不会被误解为8进制
        var dateParts = dateString.split(/[- :]/);
        // 获取年、月、日、小时、分钟、秒
        var year = dateParts[0];
        var month = dateParts[1] - 1; // 月份是从0开始的，所以要减1
        var day = dateParts[2];
        var hour = dateParts[3];
        var minute = dateParts[4];
        var second = dateParts[5];

        // 使用UTC时间创建新的日期对象
        return new Date(Date.UTC(year, month, day, hour, minute, second));
    },
    // 授权中字符串格式时间转换为天数
    convertTime(input) {
        const regex = /(?:(\d+)天)?(?:(\d+)时)?(?:(\d+)分)?(?:(\d+)秒)?/;
        const matches = input.match(regex);
        if (!matches || input === '') {
            return;
        }
        const days = parseInt(matches[1] || 0);
        const hours = parseInt(matches[2] || 0);
        const minutes = parseInt(matches[3] || 0);
        const seconds = parseInt(matches[4] || 0);
        // 计算总毫秒数
        const totalMs =
            days * 24 * 60 * 60 * 1000 +
            hours * 60 * 60 * 1000 +
            minutes * 60 * 1000 +
            seconds * 1000;

        // 计算总天数（含小数）
        const totalDays = Math.floor(totalMs / (60 * 60 * 1000));
        return totalDays
    },
    // 复制方法
    commonCopy(value, msg) {
        var aux = document.createElement("input");
        aux.setAttribute("value", value);
        document.body.appendChild(aux);
        aux.select();
        document.execCommand("copy");
        document.body.removeChild(aux);
        if (msg) {
            Toast(msg);
        }
    },
    // 只能是数字，并保留两位小数，且整数部分开头不能为0
    limitFloat(val) {
        let sNum = val.toString(); //先转换成字符串类型
        if (sNum.indexOf('.') == 0) {//第一位就是 .
            sNum = '0' + sNum
        }
        sNum = sNum.replace(/[^\d.]/g, "");  //清除“数字”和“.”以外的字符
        sNum = sNum.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
        sNum = sNum.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
        sNum = sNum.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');//只能输入两个小数
        //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        if (sNum.indexOf(".") < 0 && sNum != "") {
            sNum = parseFloat(sNum);
        }
        return sNum
    },
    // 设备检测工具函数
    detectDevice() {
        const userAgent = navigator.userAgent.toLowerCase()
        const isMobile = /mobile|android|iphone|ipad|phone/i.test(userAgent)
        const isTablet = /ipad|tablet/i.test(userAgent) && !isMobile
        const isPC = !isMobile && !isTablet

        return {
            isMobile,
            isTablet,
            isPC,
            deviceType: isMobile ? 'mobile' : isTablet ? 'tablet' : 'pc'
        }
    },
    // 复制方法
    copy(value, toast) {
        var aux = document.createElement("input");
        aux.setAttribute("value", value);
        document.body.appendChild(aux);
        aux.select();
        document.execCommand("copy");
        document.body.removeChild(aux);
        if (toast) {
            Toast(toast);
        }
    },
    moreCopy(value, toast) {
        return new Promise((resolve) => {
            //如果复制单行，用input
            //如果复制多行，用textarea
            const copyUrl = document.createElement("textarea"); //创建一个textarea框获取需要复制的文本内容
            copyUrl.value = value;
            const appDiv = document.getElementById("app");
            appDiv.appendChild(copyUrl);
            copyUrl.select();
            document.execCommand("Copy");
            copyUrl.remove();
            resolve(true);
            if (toast) {
                Toast(toast);
            }
        });
    },
    /**
 * 检查数组是否存在指定元素，存在则替换，不存在则添加
 * @param {Array} arr - 目标数组
 * @param {*} target - 要查找/替换的元素
 * @param {*} replacement - 替换的新元素（可选，不传则直接添加target）
 * @returns {Array} 处理后的新数组
 */
    checkAndUpdateArray(arr, target, isType, replacement) {
        const index = arr.findIndex(item => item[isType] === target[isType]);
        const newArray = [...arr];
        if (index !== -1) {
            newArray[index] = replacement !== undefined ? replacement : target;
        } else {
            newArray.push(replacement !== undefined ? replacement : target);
        }

        return newArray;
    }

}


